<cerrix-workspace
    [tabID]="tabID"
    [cerrixTab]="tab"
    [headerLookup]="headerLookup"
    [data]="data"
    [module]="'MailMessages'"
    [moduleLabel]="'sentOverview.workspaceModuleLabel' | t"
    [moduleLabelPlural]="'sentOverview.workspaceModuleLabelPlural' | t"
    [moduleType]="moduleType"
    [appendToModuleType]="'sentmails'"
    [idProp]="'ID'"
    [permissions]="permissions"
    (onDblClick)="openMailMessage($event)"
    [DateProperties]="dateProps"
    [rendererConfig]="rendererConfig"
    [filterConfig]="filterConfigs"
    [useLightWorkspace]="true"
>
</cerrix-workspace>

<ng-template #contentOnlyNotice let-notice="notice">
    <div class="content-only-notice">
        <i class="fas fa-info-circle" aria-hidden="true"></i>
        <span>{{ notice }}</span>
    </div>
</ng-template>
